import { TaskState, TaskAction } from 'stores/Recognition/types';

export enum SocketDataType {
  NEW_TRANSACTION = 'NEW_TRANSACTION',
  taskUpdate = 'taskUpdate',
  NEW_ONLINE_ORDERS = 'NEW_ONLINE_ORDERS',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_REQUEST_TO_CANCEL = 'ORDER_REQUEST_TO_CANCEL',
  ORDER_CANCEL_DECLINED = 'ORDER_CANCEL_DECLINED',
  DEPOSIT_ITEMS_REQUEST_CONFIRM = 'DEPOSIT_ITEMS_REQUEST_CONFIRM',
  DEPOSIT_ITEMS_REQUEST_COMPLETED = 'DEPOSIT_ITEMS_REQUEST_COMPLETED',
}

export interface SocketData<T = unknown> {
  type: SocketDataType;
  payload: T;
}

export interface TransactionData
  extends SocketData<{
    source: 'EXTERNAL' | 'INTERNAL';
  }> {}

export interface TaskUpdateData
  extends SocketData<{
    id: string;
    type: string;
    state: TaskState;
    metrics: Record<string, string> & {
      progress?: string;
    };
    wfAllowedActions: TaskAction[];
    finishedAt: string;
  }> {}

export interface NewOnlineOrdersData
  extends SocketData<{
    lastCreatedDate: string;
  }> {}

export interface DepositItemsRequestConfirmData
  extends SocketData<{
    deviceName: string;
    pin: string;
  }> {}

export interface DepositItemsRequestCompleteData
  extends SocketData<{
    deviceName: string;
  }> {}

export interface OrderCancelData
  extends SocketData<{
    orderId: string;
    orderDate: string;
  }> {}

export interface OrderRequestToCancelData
  extends SocketData<{
    orderId: string;
    orderDate: string;
  }> {}

export interface OrderCancelDeclinedData
  extends SocketData<{
    orderId: string;
    orderDate: string;
  }> {}
